/*
 * ॐ नमः शिवाय
 * Copyright (c) 2025 Rudra Coresoft Technologies Private Limited
 *
 * What a field's own settings panel needs to know about the form around it.
 *
 * A lookup field has to offer the application's tables, and a dependent lookup
 * has to offer the form's other fields. Both sit five components below the
 * editor that holds them, so they arrive by context rather than through five
 * layers of props that no intermediate component cares about.
 */

import { createContext, useContext } from 'react';

export const FormBuilderContext = createContext({ appId: null, fields: [] });

export function useFormBuilderContext() {
  return useContext(FormBuilderContext);
}
